var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlacketFrench(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: -1.5,
    width: 2.81616,
    height: 63.3636,
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1396 -1.5H70.9558V2.5H68.1396V-1.5ZM68.1396 6.5H70.9558V10.5H68.1396V6.5ZM68.1396 14.5V18.5H70.9558V14.5H68.1396ZM68.1396 26.5V22.5H70.9558V26.5H68.1396ZM68.1396 30.5V34.5H70.9558V30.5H68.1396ZM68.1396 42.5V38.5H70.9558V42.5H68.1396ZM68.1396 46.5V50.5H70.9558V46.5H68.1396ZM68.1396 58.5V54.5H70.9558V58.5H68.1396Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.5918,
    y: 10.5,
    width: 2.81616,
    height: 38.0182,
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.6411,
    cy: 29.5318,
    r: 13.0318,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.4473,
    cy: 25.1847,
    rx: 1.51049,
    ry: 1.88812,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.2951,
    cy: 29.3386,
    rx: 1.88812,
    ry: 1.51049,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.4473,
    cy: 33.8704,
    r: 1.51049,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9792,
    cy: 29.3386,
    r: 1.51049,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6412 42.5637C32.4554 42.5637 26.6094 36.7176 26.6094 29.5318C26.6094 22.346 32.4554 16.5 39.6412 16.5C46.827 16.5 52.6729 22.346 52.6729 29.5318C52.6729 36.7176 46.8268 42.5637 39.6412 42.5637ZM39.6412 17.1533C32.8156 17.1533 27.2625 22.7063 27.2625 29.5318C27.2625 36.3574 32.8154 41.9104 39.641 41.9104C46.4666 41.9104 52.0195 36.3574 52.0195 29.5318C52.0197 22.7063 46.4666 17.1533 39.6412 17.1533ZM39.6412 39.2731C34.2698 39.2731 29.8999 34.9032 29.8999 29.5318C29.8999 24.1606 34.2698 19.7906 39.6412 19.7906C45.0125 19.7906 49.3824 24.1605 49.3824 29.5318C49.3824 34.9031 45.0123 39.2731 39.6412 39.2731ZM39.6412 20.444C34.63 20.444 30.5532 24.5208 30.5532 29.5319C30.5532 34.543 34.63 38.62 39.6412 38.62C44.6523 38.62 48.7291 34.5432 48.7291 29.5319C48.7291 24.5208 44.6523 20.444 39.6412 20.444ZM39.6412 35.9112C38.5488 35.9112 37.6601 35.0225 37.6601 33.9301C37.6601 32.8378 38.5488 31.949 39.6412 31.949C40.7335 31.949 41.6222 32.8378 41.6222 33.9301C41.6222 35.0225 40.7334 35.9112 39.6412 35.9112ZM39.6412 32.6022C38.909 32.6022 38.3133 33.198 38.3133 33.9301C38.3133 34.6623 38.909 35.2579 39.6412 35.2579C40.3733 35.2579 40.969 34.6622 40.969 33.9301C40.969 33.198 40.3733 32.6022 39.6412 32.6022ZM44.0394 31.5128C42.947 31.5128 42.0583 30.6242 42.0583 29.5318C42.0583 28.4394 42.947 27.5507 44.0394 27.5507C45.1318 27.5507 46.0206 28.4394 46.0206 29.5318C46.0206 30.6242 45.1318 31.5128 44.0394 31.5128ZM44.0394 28.204C43.3072 28.204 42.7116 28.7997 42.7116 29.5318C42.7116 30.2638 43.3072 30.8596 44.0394 30.8596C44.7716 30.8596 45.3673 30.2638 45.3673 29.5318C45.3673 28.7997 44.7716 28.204 44.0394 28.204ZM35.2429 31.5128C34.1505 31.5128 33.2619 30.6242 33.2619 29.5318C33.2619 28.4394 34.1505 27.5507 35.2429 27.5507C36.3353 27.5507 37.224 28.4394 37.224 29.5318C37.224 30.6242 36.3352 31.5128 35.2429 31.5128ZM35.2429 28.204C34.5108 28.204 33.9151 28.7997 33.9151 29.5318C33.9151 30.2638 34.5108 30.8596 35.2429 30.8596C35.9751 30.8596 36.5707 30.2638 36.5707 29.5318C36.5707 28.7997 35.9751 28.204 35.2429 28.204ZM39.6412 27.1146C38.5488 27.1146 37.6601 26.2259 37.6601 25.1335C37.6601 24.0412 38.5488 23.1525 39.6412 23.1525C40.7335 23.1525 41.6222 24.0412 41.6222 25.1335C41.6222 26.2259 40.7334 27.1146 39.6412 27.1146ZM39.6412 23.8057C38.909 23.8057 38.3133 24.4015 38.3133 25.1335C38.3133 25.8656 38.909 26.4614 39.6412 26.4614C40.3733 26.4614 40.969 25.8656 40.969 25.1335C40.969 24.4015 40.3733 23.8057 39.6412 23.8057Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 59,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacketFrench);
export default __webpack_public_path__ + "static/media/placket_french.752f7f5bb93d2baa915d76e664a09843.svg";
export { ForwardRef as ReactComponent };